import { Injectable } from '@angular/core';
import { ToastrService} from "ngx-toastr";

@Injectable()
export class MessageService {

  constructor(private toastr: ToastrService) { }

  public clear(){
    this.toastr.clear();
  }
  public showInfo(message: string, disableTimeOut: boolean, title: string = 'Внимание!'): number {
    return this.toastr.info(message, title, {
      closeButton: !disableTimeOut,
      disableTimeOut: disableTimeOut,
      timeOut: disableTimeOut ? 0 : 10000,
      extendedTimeOut: disableTimeOut ? 0 : 10000,
      progressBar: !disableTimeOut,
      progressAnimation: "increasing"
    }).toastId;
  }

  public showSuccess(message: string, disableTimeOut: boolean, title: string = 'Внимание!'): number {
    return this.toastr.success(message, title, {
      closeButton: !disableTimeOut,
      disableTimeOut: disableTimeOut,
      timeOut: disableTimeOut ? 0 : 10000,
      extendedTimeOut: disableTimeOut ? 0 : 10000,
      progressBar: !disableTimeOut,
      progressAnimation: "increasing"
    }).toastId;
  }

  public showError(message: string, disableTimeOut: boolean, title: string = 'Ошибка!'): number {
    return this.toastr.warning(message, title, {
      closeButton: !disableTimeOut,
      disableTimeOut: disableTimeOut,
      timeOut: disableTimeOut ? 0 : 10000,
      extendedTimeOut: disableTimeOut ? 0 : 10000,
      progressBar: !disableTimeOut,
      progressAnimation: "increasing"
    }).toastId;
  }

  public hideMessage(id: number) {
    this.toastr.remove(id);
  }
}
